import { render, staticRenderFns } from "./UserInvitationDialog.vue?vue&type=template&id=7f124f58&scoped=true"
import script from "./UserInvitationDialog.vue?vue&type=script&lang=ts"
export * from "./UserInvitationDialog.vue?vue&type=script&lang=ts"
import style0 from "./UserInvitationDialog.vue?vue&type=style&index=0&id=7f124f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f124f58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
